import { createSelector } from '@reduxjs/toolkit';
import tableSelector from './table';

const tableRowsSelector = createSelector(tableSelector, (table) => table.rows);

export default tableRowsSelector;
